import { Card, CardContent, Skeleton, Stack } from '@mui/material'

const EmailNotificationsSkeleton = () => {
  return (
    <Card data-testid="email-notifications-skeleton">
      <CardContent>
        <Stack direction="column" spacing={1}>
          <Skeleton variant="rectangular" width={150} height={20} />
          <Skeleton variant="rectangular" width="100%" height={35} />
          <Skeleton variant="rectangular" width={200} height={20} />
        </Stack>
      </CardContent>
    </Card>
  )
}

export default EmailNotificationsSkeleton
